import { render, staticRenderFns } from "./rule-main.vue?vue&type=template&id=669f105b&lang=pug&"
import script from "./rule-main.vue?vue&type=script&lang=js&"
export * from "./rule-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports